import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ForgotPasswordForm } from '../components';
import { forgotPasswordAsync } from '../app/userSlice'
import PropTypes from 'prop-types'
import { browserName, osName  } from 'react-device-detect';
// import {} from ''

export const ForgotPassword = ({ history }) => {
    const dispatch = useDispatch();

    const handleSubmit = data => {
        const operatingSystem = osName;
        const browser = browserName
        
        const payload = {
            "email" : data.email,
            "browser": browser,
            "oS" : operatingSystem    
          }

         dispatch(forgotPasswordAsync(payload, history))
    }

    return <ForgotPasswordForm doSubmit={handleSubmit} />;
}